import { getBackgroundColor, getBorderColor, getColor, } from '../../colors/colors.alias';
import { getHeight, getWidth } from '../../sizes/sizes.alias';
import { getBorderRadius, getBorderStyle, getBorderWidth, } from '../../borders/borders.alias';
import { getFontWeight, getFontFamily, getLineHeight, getFontSize, } from '../../typography/typography.alias';
import { constants as Icon } from '../Icon';
import { VARIANT_ACHIEVED_MEDIUM, VARIANT_XS, VARIANT_XS_ATTENTIONAL, VARIANT_SMALL_ATTENTIONAL, ELEMENT_CIRCLE, ELEMENT_ICON, ELEMENT_TEXT, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Circle',
    variants: {
        VARIANT_ACHIEVED_MEDIUM,
        VARIANT_XS,
        VARIANT_XS_ATTENTIONAL,
        VARIANT_SMALL_ATTENTIONAL,
    },
    elements: {
        ELEMENT_CIRCLE,
        ELEMENT_ICON,
        ELEMENT_TEXT,
    },
});
export default function getCircle(transformer, config) {
    const backgroundColor = getBackgroundColor(transformer, config);
    const color = getColor(transformer, config);
    const fontFamily = getFontFamily(transformer, config);
    const height = getHeight(transformer);
    const borderRadius = getBorderRadius(transformer, config);
    const width = getWidth(transformer);
    const fontWeight = getFontWeight(transformer);
    const fontSize = getFontSize(transformer);
    const lineHeight = getLineHeight(transformer);
    const borderWidth = getBorderWidth(transformer, config);
    const borderStyle = getBorderStyle(transformer, config);
    const borderColor = getBorderColor(transformer, config);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_CIRCLE]: {
                styles: {
                    borderRadius: borderRadius.circle.value,
                    height: height.circle.m.value,
                    width: width.circle.m.value,
                },
                variants: {
                    [VARIANT_ACHIEVED_MEDIUM]: {
                        styles: {
                            backgroundColor: backgroundColor.feedback.positive.decorative.value,
                        },
                    },
                    [VARIANT_XS]: {
                        styles: {
                            width: width.circle.xs.value,
                            height: height.circle.xs.value,
                            borderRadius: borderRadius.circle.value,
                            backgroundColor: backgroundColor.listItem.marker.default.value,
                        },
                    },
                    [VARIANT_XS_ATTENTIONAL]: {
                        styles: {
                            width: width.circle.xs.value,
                            height: height.circle.xs.value,
                            borderRadius: borderRadius.circle.value,
                            backgroundColor: backgroundColor.listItem.marker.attentional.xs.value,
                        },
                    },
                    [VARIANT_SMALL_ATTENTIONAL]: {
                        styles: {
                            width: width.circle.s.value,
                            height: height.circle.s.value,
                            borderRadius: borderRadius.circle.value,
                            backgroundColor: backgroundColor.listItem.marker.attentional.s.value,
                            borderWidth: borderWidth.circle.smallAttentional.value,
                            borderStyle: borderStyle.circle.smallAttentional.value,
                            borderColor: borderColor.circle.smallAttentional.value,
                        },
                    },
                },
            },
            [ELEMENT_TEXT]: {
                variants: {
                    [VARIANT_SMALL_ATTENTIONAL]: {
                        styles: {
                            color: color.listItem.marker.attentional.value,
                            fontWeight: fontWeight.listItem.attentional.get(fontFamily.listItem.attentional.value),
                            fontFamily: fontFamily.listItem.attentional.value,
                            fontSize: fontSize.body.m.value,
                            lineHeight: lineHeight.body.get(fontSize.body.m.value),
                        },
                    },
                },
            },
            [ELEMENT_ICON]: {
                styles: {
                    color: color.icon.inverted.value,
                },
                components: {
                    [Icon.NAME]: {
                        variant: Icon.variants.VARIANT_SMALL,
                    },
                },
            },
        },
    });
}
